import React from 'react';

import { useTranslation } from 'react-i18next';

import './EmojiSliderDisabler.scss';

const EmojiSliderDisabler = () => {
    const { t } = useTranslation(['yat_picker']);

    return (
        <div className="emoji-slider-disabler">
            <p className="emoji-slider-disabler__paragraph">
                <span className="emoji-slider-disabler__text-fade">{t('you_have_reached_the')}&nbsp;</span>
                <span className="emoji-slider-disabler__text-highlight">
                    {t('maximum_length')}.{' '}
                    <span role="presentation" aria-hidden="true">
                        💯
                    </span>
                </span>
            </p>
        </div>
    );
};

export default EmojiSliderDisabler;
